// react-apollo hooks/components are funneled through this module so that the
// eventual Apollo Client v3 upgrade only needs to change this file.
//
// NOTE: this is intentionally a separate funnel from `apolloWithAbort.ts`:
// react-apollo ships its own nested copy of @apollo/react-hooks, which is a
// different module instance (and version) than the top-level @apollo/react-hooks
// that `apolloWithAbort.ts` re-exports. Funneling through react-apollo here
// preserves the exact module instance these consumers were already using.
export {
  ApolloProvider,
  useApolloClient,
  useLazyQuery,
  useMutation,
  useQuery,
} from 'react-apollo';
